<template>
    <div class="lg:w-3/4">
        <vx-card class="lg:p-8 w-full mb-6">
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                  <vs-input
                      class="w-full"
                      label="Название: *"
                      name="name"
                      v-model="formData.name"
                      v-validate="'required'"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <vs-input
                  class="w-full"
                  label="Описание"
                  name="description"
                  v-model="formData.description"
                />
                <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                  <label>
                    <div class="vs-input--label">Канал рассылки: *</div>
                    <v-select
                        v-model="formData.transport_slug"
                        name="transport_slug"
                        :clearable="false"
                        :reduce="option => option.value"
                        :options="transportOptions"
                        v-validate="'required'"
                    />
                </label>
                <div class="text-sm">Доступные каналы с исходящими сообщениями</div>
                <span class="text-danger text-sm" v-show="errors.has('transport_slug')">{{ errors.first('transport_slug') }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <vs-input
                    class="w-full"
                    label="Тег"
                    name="tag"
                    v-model="formData.tag"
                    v-validate="'min:2|max:16|alpha_dash'"
                />
                <div class="text-sm">При указании, всем получателям присвоится данный тег</div>
                <span class="text-danger text-sm" v-show="errors.has('tag')">{{ errors.first('tag') }}</span>
              </div>
            </div>

            <div class="vx-col w-full mb-6">
                <label>
                    <div class="vs-input--label">Шаблон сообщения: *</div>
                    <vs-textarea
                        rows="5"
                        class="w-full"
                        name="template"
                        :placeholder="templatePlaceholder"
                        v-model="formData.template"
                        v-validate="'required'"
                    />
                    <div class="text-sm">{{ templateDescription }}</div>
                    <span class="text-danger text-sm" v-show="errors.has('template')">{{ errors.first('template') }}</span>
                </label>
            </div>
  
            <div class="flex justify-end mt-6">
                <vs-button
                    class="mr-6 vs-con-loading__container"
                    :disabled="loading"
                    @click="submit"
                >
                    <div v-if="loading" class="con-vs-loading vs-loading-background-primary vs-loading-color-#fff">
                        <div class="vs-loading default" style="transform: scale(0.45);">
                        <div class="effect-1 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                        <div class="effect-2 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                        <div class="effect-3 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                        </div>
                    </div>
                    Сохранить
                </vs-button>
            </div>
      </vx-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BulkDeliveryService from '../../api/http/models/bulkDelivery/BulkDeliveryService'

import ChatFirstService from '../../api/http/models/ChatFirst'
export default {
  data () {
    return {
      formData: {},
      loading: false,
      transportList: []
    }
  },
  computed: {
    ...mapGetters(['authUserCompany']),
    transportOptions () {
      return this.transportList.map(({ channel_name, slug }) => ({ label: channel_name, value: slug }))
    },
    templatePlaceholder () {
      return 'Добрый день, {{name}}! Рады сообщить, что на ваш автомобиль {{car}} действует скидка на замену масла до {{day}} марта!'
    },
    templateDescription () {
      return 'Поддерживаются переменные в формате {{name}}'
    }
  },
  methods: {
    async submit () {
      const validate = await this.$validator.validateAll()
      if (validate) {
        try {
          this.loading = true
          const data = await BulkDeliveryService.create(this.authUserCompany.slug, this.formData)
          if (data.status === 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Рассылка создана',
              text: 'Создание рассылки прошло успешно'
            })
            this.$router.push({ name: 'bulk_delivery_tasks' })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка при создании рассылки',
              text: data.errors.template ? 'Ошибка в шаблоне, переменная внутри {{}} должна быть на английском языке' : ''
            })
          }
          
        } catch {
          this.$vs.notify({
            color: 'danger',
            title: 'Ошибка при создании рассылки',
            text: ''
          })
        } finally {
          this.loading = false
        }
                
      }
    }
  },
  async created () {
    const { data } = await ChatFirstService.getChannels(this.authUserCompany.slug)
    this.transportList = data
  }
}
</script>
